<mds-dialog dialogTitle="Request Status">
    <mds-dialog-content>
        <div class="pb-medpace">
            <medpace-payment-request-status-change-modal-content
                [formGroup]="formGroup"
                [requestType]="data.requestType"
                [requestId]="data.requestId"
                (cancel)="cancel()"
                (confirm)="confirm($event)"
            />
        </div>
    </mds-dialog-content>
</mds-dialog>
